import React from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import FileDownloader from "../download/FileDownloader";
import PointUnit from "../../common/PointUnit"

const ListComponent = ({ headers, columnRatios, items }) => {
  console.log('items 이동!', items)
  const navigate = useNavigate();

  const goToDetailPage = (item) => {
    const { file, downloadUrl, ...itemWithoutFile } = item; // downloadUrl을 제외한 나머지 항목
    navigate(`/document/${item.index}`, { state: { item: itemWithoutFile } });
  };

  return (
    <ListContainer>
      <Header columns={columnRatios}>
        {headers.map((header, index) => {
          const isCenter =
            header === "다운로드수" ||
            header === "가격" ||
            header === "업로드일" ||
            header === "자료";
          return (
            <HeaderItem key={index} isCenter={isCenter}>
              {header}
            </HeaderItem>
          );
        })}
      </Header>
      <List>
        {items?.map((item, index) => (
          <ListItem key={index} columns={columnRatios}>
            {Object.entries(item).map(([key, value], propIndex) => {
              const alignCenter =
                key === "downloaded" ||
                key === "downloadUrl" ||
                key === "created_at";
              const paddingRight = key === "price";
              if (key === "downloadUrl") {
                return (
                  <ItemProperty key={propIndex} alignCenter={alignCenter}>
                    <FileDownloader
                      url={value.url}
                      documentId={value.id}
                      point={value.price}
                    >
                      <img src="/images/pdf-icon.png" alt="PDF 다운로드" />
                    </FileDownloader>
                  </ItemProperty>
                );
              } else if (key === "name") {
                return (
                  <ItemProperty
                    key={propIndex}
                    isClickable
                    onClick={() => goToDetailPage(item)}
                    alignCenter={alignCenter}
                  >
                    {value}
                  </ItemProperty>
                );
              } else if (
                key === "docu_type1_name" ||
                key === "docu_type2_name"
              ) {
                return null;
              } else if (key === "price") {
                return (
                  <ItemProperty
                    key={propIndex}
                    alignCenter={alignCenter}
                    paddingRight={paddingRight}
                  >
                    {" "}
                    <PointUnit> {value.toLocaleString()} </PointUnit>{" "}
                  </ItemProperty>
                );
              } else {
                return (
                  <ItemProperty key={propIndex} alignCenter={alignCenter}>
                    {value}
                  </ItemProperty>
                );
              }
            })}
          </ListItem>
        ))}
      </List>
    </ListContainer>
  );
};

export default ListComponent;

const ListContainer = styled.div`
  width: 80%;
  display: flex;
  flex-direction: column;
  margin: 20px 0;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
  border-radius: 2px;
  overflow: hidden;
  background: white;
`;

const List = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

const ListItem = styled.li`
  display: grid;
  grid-template-columns: ${(props) => props.columns};
  gap: 11px;
  padding: 8px 16px;
  align-items: center;
  border-bottom: 1px solid #eee;
  transition: background-color 0.2s ease-in-out;

  &:hover {
    background-color: #f9f9f9;
  }

  &:last-child {
    border-bottom: none;
  }
`;

const ItemProperty = styled.span`
  width: 100%;
  margin: 0;
  // padding: 4px;
  text-align: ${({ alignCenter }) => (alignCenter ? "center" : "left")};
  padding-right: ${(paddingRight) => (paddingRight ? "2rem" : "0rem")}
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-right: 2px;

  ${(props) =>
    props.isClickable &&
    `
  &:hover {
    text-decoration: underline;
    cursor: pointer;
  }
`}
`;

const Header = styled.div`
  display: grid;
  grid-template-columns: ${(props) => props.columns};
  text-align: left;
  background: #f5f5f5;
  color: #333;
  font-weight: bold;
  padding: 16px;
  gap: 10px;
`;

const HeaderItem = styled.div`
  text-align: ${({ isCenter }) => (isCenter ? "center" : "left")};
`;
